import { DevPage } from '@/pages/dev/dev.page';
import { ExportPage } from '@/pages/export/export.page';
import { LoginPage } from '@/pages/login/login.page';
import { PreTailoringPage } from '@/pages/pre-tailoring/pre-tailoring.page';
import { ProductsPage } from '@/pages/products/products.page';
import { RedirectPage } from '@/pages/redirect/redirect.page';
import { TailoringPage } from '@/pages/tailoring/tailoring.page';
import { useAccount, useMsal } from '@azure/msal-react';
import { Navigate, Outlet, Route, BrowserRouter as Router, Routes } from 'react-router-dom';

const PrivateRoute = () => {
  const { accounts } = useMsal();
  const account = useAccount(accounts[0]);
  return account ? <Outlet /> : <Navigate to="/login" />;
};

const BaseRoute = () => {
  const { accounts } = useMsal();
  const account = useAccount(accounts[0]);
  return account ? <Navigate to="/products" /> : <Outlet />;
};

export const RouterContainer = () => {
  return (
    <Router>
      <Routes>
        <Route element={<PrivateRoute />}>
          <Route path="/products" element={<ProductsPage />} />
          <Route path="/product/:id/pre-tailoring" element={<PreTailoringPage />} />
          <Route path="/product/:id/tailoring" element={<TailoringPage />} />
          <Route path="/product/:id/export" element={<ExportPage />} />
          <Route path="/dev/test" element={<DevPage />} />
        </Route>
        <Route element={<BaseRoute />}>
          <Route path="/redirect" element={<RedirectPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="*" element={<Navigate to="/login" />} />
        </Route>
      </Routes>
    </Router>
  );
};
